var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingSectionEllipsGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 514,
    viewBox: "0 0 320 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 232.335,
    cy: 232.335,
    r: 230.835,
    transform: "matrix(-1 0 0 1 464.671 -41.834)",
    stroke: "#FF5349",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 183.932,
    cy: 183.932,
    r: 181.932,
    transform: "matrix(-1 0 0 1 485 145.97)",
    stroke: "#FF5349",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingSectionEllipsGroup);
export default __webpack_public_path__ + "static/media/pricingSectionEllipsGroup.e5a1c87cf41fdb445805c98776c17922.svg";
export { ForwardRef as ReactComponent };